export const LIMITS_STATUS_STATE_KEY = 'limitsStatus'

export const CONTENT_LOAD = 'Casino/LimitsStatus/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/LimitsStatus/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/LimitsStatus/LOAD_ERROR'
